import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { DateHeading as BaseDateHeading } from '@mews-distributor/ui';
import { showDates } from '../../actions/navigation';
import { getParsedEndDate, getParsedStartDate } from '../../modules/resourceOrder/selectors';
import { ApplicationState } from '../../types';

export const DateHeading = connect<
    Pick<React.ComponentProps<typeof BaseDateHeading>, 'startDate' | 'endDate'>,
    Pick<React.ComponentProps<typeof BaseDateHeading>, 'onClick'>,
    {},
    ApplicationState
>(
    createStructuredSelector({
        startDate: getParsedStartDate,
        endDate: getParsedEndDate,
    }),
    {
        onClick: showDates,
    }
)(BaseDateHeading);
